import { setup, fromPromise, assertEvent } from 'xstate5'
import { type Emits as EmitsCreateExpenseReportPure } from '@/components/PmCreateExpenseReport/PmCreateExpenseReportPure.vue'
import { assertFriendlyError } from '@/functional/friendlyErrors'

export const PmCreateExpenseReportState = setup({
  types: {
    events: {} as {
      type: 'create'
      variables: EmitsCreateExpenseReportPure['submit']
    },

    context: {} as {
      error: string | undefined
      errorDetails: string[] | undefined
    },
  },

  actions: {
    showSuccessNotification: () => {
      throw new Error('showSuccessNotification not implemented')
    },

    emitClose: () => {
      throw new Error('emitClose not implemented')
    },
  },

  actors: {
    createExpenseReport: fromPromise<
      void,
      { variables: EmitsCreateExpenseReportPure['submit'] }
    >(async () => {
      throw new Error('createExpenseReport not implemented')
    }),
  },
}).createMachine({
  id: 'PmCreateExpenseReport',
  initial: 'default',

  context: {
    error: undefined,
    errorDetails: undefined,
  },

  states: {
    default: {
      on: {
        create: 'create',
      },
    },

    create: {
      initial: 'saving',

      states: {
        saving: {
          invoke: {
            id: 'createExpenseReport',
            src: 'createExpenseReport',
            input: ({ event }) => {
              assertEvent(event, 'create')
              return { variables: event.variables }
            },
            onDone: {
              target: 'success',
            },
            onError: {
              target: 'error',
              actions: ({ context, event }) => {
                assertFriendlyError(event.error)

                context.error = event.error.message
                context.errorDetails = event.error.details
              },
            },
          },
        },
        error: {
          on: {
            create: '#PmCreateExpenseReport.create',
          },
        },
        success: {
          entry: ['showSuccessNotification', 'emitClose'],
          type: 'final',
        },
      },
    },
  },
})
